import ReactDOM from 'react-dom/client';
import { StrictMode } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/react-query';
import { router } from '@/lib/react-router';
import '@/index.css';

console.info(`Running in ${process.env.NODE_ENV || 'undefined'} mode`);

const root = document.getElementById('root');

if (!root) throw new Error('Missing root element');

ReactDOM.createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} context={{}} />
    </QueryClientProvider>
  </StrictMode>
);
